<!--
 * @Description: 
 * @Date: 2020-09-26 17:05:46
 * @LastEditors: jml
-->
<template>
  <van-form @submit="onSubmit" class="game-address-form">
    <van-field v-model="name" name="name" label="姓名" placeholder="请填写姓名" maxlength="10" />
    <van-field v-model="tel" name="tel" label="联系方式" placeholder="请填写手机号" maxlength="11" />
    <div class="area">
      <van-field
        readonly
        clickable
        name="area"
        :value="value"
        label="选择地区"
        placeholder="请选择地区"
        @click="showArea = true"
        class="area-input"
      />
      <van-icon class="icon" name="arrow" />
    </div>
    <van-field
      v-model="address"
      name="address"
      label="详细地址"
      placeholder="请填写街道、楼牌号等"
      maxlength="50"
    />
    <div>
      <van-button class="btn" block type="info" native-type="submit" :disabled="disabled">完成</van-button>
    </div>
    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>
  </van-form>
</template>

<script>
import areaList from '../config/area';
import { puzzle } from '@/api/game';
export default {
  name: 'address',
  data() {
    return {
      name: '',
      tel: '',
      address: '',
      value: '',
      showArea: false,
      areaList: areaList,
      provinceName: '',
      cityName: '',
      districtName: ''
    };
  },
  props: {
    success: {},
    callback: {}
  },
  computed: {
    disabled() {
      return (
        !this.name || !this.validate(this.tel) || !this.value || !this.address
      );
    }
  },
  methods: {
    validate(item) {
      if (/^1[0-9]{10}$/.test(item)) {
        return true;
      } else {
        return false;
      }
    },
    onConfirm(values) {
      this.value = values.map(item => item.name).join('');
      this.provinceName = (values[0] || {}).name || '';
      this.cityName = (values[1] || {}).name || '';
      this.districtName = (values[2] || {}).name || '';
      this.showArea = false;
    },
    onSubmit(e) {
      const { id, channelNo } = this.$route.params;
      const { provinceName, cityName, districtName } = this;
      const obj = {
        channelNo,
        consignee: e.name,
        consigneePeople: e.tel,
        provinceName,
        cityName,
        districtName,
        address: e.address
      };
      puzzle.addUpdateAddress(obj).then(res => {
        this.success && this.success(obj);
        this.callback && this.callback(obj);
        try {
          this.$parent.$parent.show = false;
        } catch (error) {
          console.warn(error);
        }
      });
    }
  },
  async created() {
    const { channelNo } = this.$route.params;
    const addressRes = await puzzle.addressData({ channelNo });
    const {
      address,
      provinceName,
      cityName,
      districtName,
      consigneePeople,
      consignee
    } = addressRes.data.data || {};
    this.name = consignee;
    this.tel = consigneePeople;
    this.provinceName = provinceName;
    this.cityName = cityName;
    this.districtName = districtName;
    this.value = provinceName ? provinceName + cityName + districtName : '';
    this.address = address;
  }
};
</script>
<style lang="less" >
.game-address-form {
  .van-cell {
    padding: 0.43rem 0;
    .van-field__label {
      font-size: 0.43rem;
      color: #6b6c6f;
    }
    .van-field__control {
      font-size: 0.43rem;
      color: #323235;
      text-align: right;
    }
    &::after {
      left: 0;
      right: 0;
    }
  }
  .area {
    display: flex;
    align-items: center;
    position: relative;
    .area-input {
      padding-right: 0.4rem;
    }
    .icon {
      position: absolute;
      color: #3667ec;
      font-weight: bold;
      font-size: 0.4rem;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
  }
  .btn {
    width: 100%;
    height: 1.28rem;
    border-radius: 0.21rem;
    margin: 0 auto;
    margin-top: 1.6rem;
  }
}
</style>